
const codeWriterPrompt =(inputCode)=>{
  return `Given an unit test, write code that implements the functionality described by the tests. Do not include the test cases themselves, only the code that satisfies them. Unit test is \n ${inputCode}.`;

} 

const testWriterprompt=(testOption,inputCode)=>{
  const TestOptions = {
    FunctionalTest: "functionalTest",
    UnitTest: "unitTest",
  };
  const functionalTestPrompt = `write functional test scenarios that needs to be tested 
                    for the following function \n ${inputCode} \n. 
                    Also, mention which scenario can be tagged as a smoke test. 
                    Lastly write the full test code for all the scenarios 
                    in the format \n Scenario: \n Test code: \n.`;
  const unitTestPrompt = `write unit test code for the following function \n ${inputCode} \n in the format \n Scenario: \n Test code: \n.`;
  const prompt =
    testOption === TestOptions.FunctionalTest
          ? functionalTestPrompt
          : unitTestPrompt;
    return prompt;        

}

const generateDocPrompt = (inputCode)=>{
    return `Generate detailed documentation for the following code \n ${inputCode}. \n
in the format \n Documentation tool name: \n Code with Documentation: \n Command to generate documentation: \n.`;

}

const GenerateServerSidePerformanceTestsPrompt = (fromData)=>{ 
    return `Here are some APIs for which I have to write automated performance tests: \n
             - Endpoint: ${fromData.endpoint} \n
             - Method: ${fromData.method} \n
             - Payload: ${fromData.payload} \n
             - Sample Response: ${fromData.responseSample} \n
             Can you write a automated performance testing of type ${fromData.type} testing and 
             scripts to test these using ${fromData.tool},
             in the format: \n
             \n Tool name : 
            \n **************** \n
            \n setup and installation process: \n
            \n Folder structure: \n (Suggest a root folder name)
            \n File name: \n
            \n Code: \n
            *************************************
            Do not include Sample response. 
            Make sure to write the whole response in Markdown format
            `;
}

const securityThreatsCheckerPrompt =(inputCode)=>{
     return  `Check for application security threats \n ${inputCode}. \n 
      Also, explain which line of code has problem and how to fix it 
      using the following format \n Line number: \n Problem: \n Solution: \n. 
      In the solution, provide actual code to fix, in the format \n Proable code: \n.
      Also, mention the name of the security threat and 
      the severity of the threat.`;
    }

export  { testWriterprompt, generateDocPrompt, GenerateServerSidePerformanceTestsPrompt, securityThreatsCheckerPrompt, codeWriterPrompt};